import React from "react";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import {
  getAnnualRate,
  getWeeklyRate,
  hasCalculatorData,
} from "./MarketingCard.utils";
import {
  CardGridItem,
  Card,
  CardHeader,
  CardTitle,
  NorthEastIcon,
  CardBody,
  CalculatorButton,
  CalculatorButtonLabel,
  EastIcon,
  CalculatorResult,
  CalculatorResultText,
  BoldText,
  TagsContainer,
  Tag,
  TagLabel,
} from "./MarketingCard.styles";

const MarketingCard = ({ item, onClickCalculator, onClick, link }) => {
  const { userData } = useSelector((state) => state.user);

  const annualRate = getAnnualRate(userData);
  const weeklyRate = getWeeklyRate(userData);
  const showCalculatorResult =
    item?.type === "calculator" && hasCalculatorData(userData);

  const handleCardClick = link ? onClick : null;

  return (
    <CardGridItem item size={{ xs: 12, sm: 6 }}>
      <Card isClickable={!!link} onClick={handleCardClick}>
        <CardHeader
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <CardTitle>{item?.title}</CardTitle>
          {link && <NorthEastIcon />}
        </CardHeader>

        <CardBody dangerouslySetInnerHTML={{ __html: item?.text }} />

        {item?.type === "calculator" && (
          <CalculatorButton
            onClick={(e) => {
              e.stopPropagation();
              onClickCalculator();
            }}
          >
            <CalculatorButtonLabel>Calculator</CalculatorButtonLabel>
            <EastIcon />
          </CalculatorButton>
        )}

        {showCalculatorResult && (
          <CalculatorResult>
            <CalculatorResultText>
              On or before
              <BoldText component="span">
                {" "}
                {dayjs(userData?.startDate).format("MM/DD/YYYY")}
              </BoldText>
              , I see
              <BoldText component="span"> {userData?.clients}</BoldText>{" "}
              full-paying clients per week to earn
              <BoldText component="span"> ${weeklyRate}</BoldText> per week and
              <BoldText component="span"> ${annualRate}</BoldText> per year.
            </CalculatorResultText>
          </CalculatorResult>
        )}

        {item?.type === "tags" && (
          <TagsContainer>
            {item?.tags?.map((tag, idx) => (
              <Tag key={idx}>
                <TagLabel>{tag}</TagLabel>
              </Tag>
            ))}
          </TagsContainer>
        )}

        {item?.bottomText && <CardBody>{item?.bottomText}</CardBody>}
      </Card>
    </CardGridItem>
  );
};

export default MarketingCard;
